import React, { useState, memo, useEffect } from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import { Button, Grid, TextField, InputAdornment } from '@material-ui/core';
import {
  Add, CloudDownload, CloudUpload, Search,
} from '@material-ui/icons';
import { useDebounce } from 'use-debounce';
import styles from '../../Synonyms.module.scss';

export const TableToolbar = memo(({
  searchTerm,
  onSearchChange,
  onAddSynonym,
  onImport,
  onExport,
  canExport,
  showSearch,
}) => {
  const localizeMessage = useLocalizedMessage();
  const [localSearch, setLocalSearch] = useState(searchTerm || '');
  const [debouncedSearch] = useDebounce(localSearch, 200);

  useEffect(() => {
    setLocalSearch(searchTerm || '');
  }, [searchTerm]);

  useEffect(() => {
    onSearchChange({ target: { value: debouncedSearch } });
  }, [debouncedSearch, onSearchChange]);

  const handleAddClick = () => {
    setLocalSearch('');
    onSearchChange({ target: { value: '' } });
    onAddSynonym();
  };

  return (
    <Grid container spacing={2} alignItems="center" className={styles.toolbar}>
      {showSearch && (
        <Grid item xs={12} md={6}>
          <TextField
            className={styles.search}
            fullWidth
            variant="outlined"
            size="small"
            placeholder={localizeMessage('customization.synonyms.placeholder.searchTerms')}
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
            inputProps={{
              'aria-label': localizeMessage('customization.synonyms.placeholder.searchTerms'),
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}

      <Grid item xs={12} md={showSearch ? 6 : 12}>
        <div className={styles.toolbarActions}>
          <Button
            className={styles.addButton}
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={handleAddClick}
          >
            {localizeMessage('search.synonyms.actions.addGroup')}
          </Button>
          <Button
            className={styles.importButton}
            variant="outlined"
            startIcon={<CloudUpload />}
            onClick={onImport}
            data-testid="synonyms-import-open"
          >
            {localizeMessage('search.synonyms.import.action')}
          </Button>
          <Button
            className={styles.exportButton}
            variant="outlined"
            startIcon={<CloudDownload />}
            onClick={onExport}
            disabled={!canExport}
            data-testid="synonyms-export"
          >
            {localizeMessage('search.synonyms.export.action')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
});
